import React from 'react';
import { canExpand, descriptionId, getTemplate, getUiOptions, titleId } from '@rjsf/utils';
import styles from '../rjsf.module.css';

// Default object rendering has no visual separation between properties — lay them out in
// a flex column instead of the browser's default <fieldset> spacing.
const ObjectFieldTemplate = (props) => {
  const {
    description,
    disabled,
    formData,
    idSchema,
    onAddClick,
    properties,
    readonly,
    registry,
    required,
    schema,
    title,
    uiSchema,
  } = props;
  const options = getUiOptions(uiSchema);
  const TitleFieldTemplate = getTemplate('TitleFieldTemplate', registry, options);
  const DescriptionFieldTemplate = getTemplate('DescriptionFieldTemplate', registry, options);
  const {
    ButtonTemplates: { AddButton },
  } = registry.templates;

  return (
    <div id={idSchema.$id} className={styles.objectFieldTemplate}>
      {title && (
        <TitleFieldTemplate
          id={titleId(idSchema)}
          title={title}
          required={required}
          schema={schema}
          uiSchema={uiSchema}
          registry={registry}
        />
      )}
      {description && (
        <DescriptionFieldTemplate
          id={descriptionId(idSchema)}
          description={description}
          schema={schema}
          uiSchema={uiSchema}
          registry={registry}
        />
      )}
      {properties.map((prop) => (
        <div key={prop.name}>{prop.content}</div>
      ))}
      {canExpand(schema, uiSchema, formData) && (
        <AddButton
          className="object-property-expand"
          onClick={onAddClick(schema)}
          disabled={disabled || readonly}
          uiSchema={uiSchema}
          registry={registry}
        />
      )}
    </div>
  );
};

export default ObjectFieldTemplate;
